import { render, staticRenderFns } from "./updatePatent.vue?vue&type=template&id=420ef052"
import script from "./updatePatent.vue?vue&type=script&lang=js"
export * from "./updatePatent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports